import React from 'react';
import { Col, DatePicker, Form, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const DateSection = ({ isView }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Date')}</Typography.Title>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Inizio pubblicazione')} name='published_at'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item
          label={t('Data inizio promozione')}
          name='from'
          rules={[
            {
              required: true,
              message: t('Data inizio promozione valore errato'),
            },
          ]}
        >
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Data fine promozione')} name='to'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(DateSection);
